import request from '@/utils/request.js'


export function getDefinitionUrlList(params) {
    return request({
        url:"/alivod/definition-url-list",
        method:"get",
        params
    });
}
